import RouteComponent from "./routes";

const App = () => <RouteComponent />;

export default App;

